import { render, staticRenderFns } from "./Coordonne.vue?vue&type=template&id=2be8f51a&"
import script from "./Coordonne.vue?vue&type=script&lang=js&"
export * from "./Coordonne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports